var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-responsive', {
    staticClass: "mx-auto overflow-visible",
    attrs: {
      "max-width": "1024px",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "headline text-start mt-8"
  }, [_vm.application._id ? _c('span', [_vm._v("유통데이터 활용 지원 수정")]) : _c('span', [_vm._v("유통데이터 활용 지원 등록")])]), _c('section', {
    staticClass: "mt-4"
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_vm._v("제목")]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.application.subject,
      callback: function callback($$v) {
        _vm.$set(_vm.application, "subject", $$v);
      },
      expression: "application.subject"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_vm._v("작성일")]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.$dayjs(_vm.application.createdAt).format('YYYY-MM-DD HH:mm:ss'),
      "type": "datetime-local",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "change": function change(value) {
        return _vm.application.createdAt = _vm.$dayjs(value).toDate();
      }
    }
  }), _c('div', {
    staticClass: "text-caption primary--text"
  }, [_vm._v("* 작성일이 최신일수록 상단에 노출됩니다")])], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_vm._v("상태")]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.statuses,
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.application.status,
      callback: function callback($$v) {
        _vm.$set(_vm.application, "status", $$v);
      },
      expression: "application.status"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_vm._v("지원하기 링크")]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "placeholder": "https://"
    },
    model: {
      value: _vm.application.link,
      callback: function callback($$v) {
        _vm.$set(_vm.application, "link", $$v);
      },
      expression: "application.link"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_vm._v("보고서 제출 링크")]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "placeholder": "https://"
    },
    model: {
      value: _vm.application.link2,
      callback: function callback($$v) {
        _vm.$set(_vm.application, "link2", $$v);
      },
      expression: "application.link2"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_vm._v(" 썸네일 "), _c('div', [_vm._v("이미지사이즈 : 282x370(px)")])]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('div', [_vm.application.thumb ? [_c('v-layout', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": "",
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.application.thumb = null;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("mdi-close")])], 1)], 1), _c('v-card', {
    staticStyle: {
      "border-style": "dotted",
      "border-width": "2px"
    },
    attrs: {
      "outlined": "",
      "width": "100%"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.application.thumb.src,
      "height": "373",
      "contain": ""
    }
  })], 1)] : _c('v-sheet', {
    staticClass: "d-flex",
    staticStyle: {
      "border-style": "dotted",
      "border-width": "2px",
      "cursor": "pointer"
    },
    attrs: {
      "outlined": "",
      "width": "100%",
      "height": "373"
    },
    on: {
      "click": function click($event) {
        var _vm$$refs$thumb, _vm$$refs$thumb$$refs, _vm$$refs$thumb$$refs2, _vm$$refs$thumb$$refs3;
        (_vm$$refs$thumb = _vm.$refs.thumb) === null || _vm$$refs$thumb === void 0 ? void 0 : (_vm$$refs$thumb$$refs = _vm$$refs$thumb.$refs) === null || _vm$$refs$thumb$$refs === void 0 ? void 0 : (_vm$$refs$thumb$$refs2 = _vm$$refs$thumb$$refs.input) === null || _vm$$refs$thumb$$refs2 === void 0 ? void 0 : (_vm$$refs$thumb$$refs3 = _vm$$refs$thumb$$refs2.click) === null || _vm$$refs$thumb$$refs3 === void 0 ? void 0 : _vm$$refs$thumb$$refs3.call(_vm$$refs$thumb$$refs2);
      }
    }
  }, [_c('div', {
    staticClass: "ma-auto"
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "18"
    }
  }, [_vm._v("mdi-file-upload")]), _c('span', [_vm._v("업로드 (.jpg, .png)")])], 1)]), _c('v-spacer')], 2), _c('v-file-input', {
    ref: "thumb",
    staticClass: "d-none",
    on: {
      "change": function change(file) {
        return _vm.upload(file).then(function (res) {
          return _vm.$set(_vm.application, 'thumb', res);
        });
      }
    }
  })], 1)], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "mt-4"
  }, [_c('v-layout', [_c('span', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("항목")])]), _c('v-card', [_c('v-card-text', {
    staticClass: "d-flex"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$set(_vm.application.items, _vm.application.items.length, {});
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "18"
    }
  }, [_vm._v("mdi-plus")]), _vm._v("추가")], 1)], 1), _vm._l(_vm.application.items, function (item, index) {
    return [_c('v-divider', {
      key: 'divider' + index
    }), _c('v-row', {
      key: index,
      staticClass: "px-4",
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "2"
      }
    }, [_c('v-textarea', {
      attrs: {
        "dense": "",
        "hide-details": "",
        "outlined": "",
        "rows": "1"
      },
      model: {
        value: item.title,
        callback: function callback($$v) {
          _vm.$set(item, "title", $$v);
        },
        expression: "item.title"
      }
    })], 1), _c('v-col', [_c('v-textarea', {
      attrs: {
        "hide-details": "",
        "outlined": "",
        "rows": "2"
      },
      model: {
        value: item.txt,
        callback: function callback($$v) {
          _vm.$set(item, "txt", $$v);
        },
        expression: "item.txt"
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-btn', {
      attrs: {
        "small": "",
        "outlined": "",
        "color": "red"
      },
      on: {
        "click": function click($event) {
          return _vm.application.items.splice(index, 1);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "size": "18"
      }
    }, [_vm._v("mdi-delete-outline")]), _vm._v("삭제")], 1)], 1)], 1)];
  })], 2)], 1), _c('section', {
    staticClass: "mt-4"
  }, [_c('v-layout', [_c('span', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("문의처")])]), _c('v-card', [_c('v-card-text', {
    staticClass: "d-flex"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$set(_vm.application.helpItems, _vm.application.helpItems.length, {});
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "18"
    }
  }, [_vm._v("mdi-plus")]), _vm._v("추가")], 1)], 1), _vm._l(_vm.application.helpItems, function (item, index) {
    return [_c('v-divider', {
      key: 'divider' + index
    }), _c('v-row', {
      key: index,
      staticClass: "px-4",
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "2"
      }
    }, [_c('v-textarea', {
      attrs: {
        "dense": "",
        "hide-details": "",
        "outlined": "",
        "rows": "1"
      },
      model: {
        value: item.title,
        callback: function callback($$v) {
          _vm.$set(item, "title", $$v);
        },
        expression: "item.title"
      }
    })], 1), _c('v-col', [_c('v-textarea', {
      attrs: {
        "hide-details": "",
        "outlined": "",
        "rows": "2"
      },
      model: {
        value: item.txt,
        callback: function callback($$v) {
          _vm.$set(item, "txt", $$v);
        },
        expression: "item.txt"
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-btn', {
      attrs: {
        "small": "",
        "outlined": "",
        "color": "red"
      },
      on: {
        "click": function click($event) {
          return _vm.application.helpItems.splice(index, 1);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "size": "18"
      }
    }, [_vm._v("mdi-delete-outline")]), _vm._v("삭제")], 1)], 1)], 1)];
  })], 2)], 1), _c('section', {
    staticClass: "mt-4"
  }, [_c('v-layout', [_c('span', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("공고문 업로드")])]), _c('v-card', [_c('v-card-text', {
    staticClass: "d-flex"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.$refs.files.$el.getElementsByTagName('input')[0].click();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "18"
    }
  }, [_vm._v("mdi-plus")]), _vm._v("추가")], 1), _c('v-file-input', {
    ref: "files",
    staticClass: "d-none",
    attrs: {
      "multiple": "",
      "accept": ".pdf, .xls, .xlsx"
    },
    on: {
      "change": function change($event) {
        _vm.upload(Array.isArray(_vm.files) ? _vm.files : [_vm.files]).then(function (res) {
          return _vm.$set(_vm.application, 'files', [].concat(_vm.application.files || [], res));
        });
      }
    },
    model: {
      value: _vm.files,
      callback: function callback($$v) {
        _vm.files = $$v;
      },
      expression: "files"
    }
  })], 1), _vm._l(_vm.application.files, function (item, index) {
    return [_c('v-divider', {
      key: 'divider' + index
    }), _c('v-row', {
      key: index,
      staticClass: "px-4",
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', [_c('v-btn', {
      attrs: {
        "color": "blue",
        "outlined": ""
      },
      on: {
        "click": function click($event) {
          return _vm.download(item.src, item.name);
        }
      }
    }, [_vm._v(_vm._s(item.name)), _c('v-icon', {
      attrs: {
        "size": "16",
        "right": ""
      }
    }, [_vm._v("mdi-download")])], 1)], 1), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-btn', {
      attrs: {
        "small": "",
        "outlined": "",
        "color": "red"
      },
      on: {
        "click": function click($event) {
          return _vm.application.files.splice(index, 1);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "size": "18"
      }
    }, [_vm._v("mdi-delete-outline")]), _vm._v("삭제")], 1)], 1)], 1)];
  })], 2)], 1), _c('section', {
    staticClass: "mt-4"
  }, [_c('v-layout', [_c('span', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("데이터 미리보기")])]), _c('v-card', [_c('v-card-text', {
    staticClass: "d-flex"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.$refs.files2.$el.getElementsByTagName('input')[0].click();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "18"
    }
  }, [_vm._v("mdi-plus")]), _vm._v("추가")], 1), _c('v-file-input', {
    ref: "files2",
    staticClass: "d-none",
    attrs: {
      "multiple": "",
      "accept": ".pdf, .xls, .xlsx"
    },
    on: {
      "change": function change($event) {
        _vm.upload(Array.isArray(_vm.files2) ? _vm.files2 : [_vm.files]).then(function (res) {
          return _vm.$set(_vm.application, 'files2', [].concat(_vm.application.files2 || [], res));
        });
      }
    },
    model: {
      value: _vm.files2,
      callback: function callback($$v) {
        _vm.files2 = $$v;
      },
      expression: "files2"
    }
  })], 1), _vm._l(_vm.application.files2, function (item, index) {
    return [_c('v-divider', {
      key: 'divider' + index
    }), _c('v-row', {
      key: index,
      staticClass: "px-4",
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', [_c('v-btn', {
      attrs: {
        "color": "blue",
        "outlined": ""
      },
      on: {
        "click": function click($event) {
          return _vm.download(item.src, item.name);
        }
      }
    }, [_vm._v(_vm._s(item.name)), _c('v-icon', {
      attrs: {
        "size": "16",
        "right": ""
      }
    }, [_vm._v("mdi-download")])], 1)], 1), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-btn', {
      attrs: {
        "small": "",
        "outlined": "",
        "color": "red"
      },
      on: {
        "click": function click($event) {
          return _vm.application.files2.splice(index, 1);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "size": "18"
      }
    }, [_vm._v("mdi-delete-outline")]), _vm._v("삭제")], 1)], 1)], 1)];
  })], 2)], 1), _c('section', {
    staticClass: "mt-4"
  }, [_c('v-layout', [_c('span', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("상세내용")])]), _c('v-card', [_c('v-card-text', [_c('naver-smarteditor', {
    model: {
      value: _vm.application.content,
      callback: function callback($$v) {
        _vm.$set(_vm.application, "content", $$v);
      },
      expression: "application.content"
    }
  })], 1)], 1)], 1), _c('v-row', {
    staticClass: "mx-1 my-4",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "auto",
      "sm": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blue darken-1"
    },
    on: {
      "click": function click($event) {
        return _vm.save();
      }
    }
  }, [_vm._v("저장")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }